import { Card } from '@skf-internal/ui-components-react-legacy';
import TwoColumnLayout from 'components/layout/TwoColumnLayout';
import LeftMenu from './LeftMenu';
import { Outlet } from 'react-router-dom';

const MasterMain = () => {
  return (
    <TwoColumnLayout
      isSecure
      left={
        <>
          <LeftMenu />
        </>
      }
      right={
        <>
          <Card className="mb-5">
            <Outlet />
          </Card>
        </>
      }
    />
  );
};

export default MasterMain;
